import { Articulo, getEmptyArticulo } from '@/types/types'
import Axios, { AxiosPromise } from 'axios'

export class ArticuloService {
  fetchAllRequest (filtro: string): AxiosPromise<{data: Articulo[]}> {
    return Axios.get(`articulos?${filtro}`)
  }

  fetchOneRequest (id: string): AxiosPromise<{data: Articulo}> {
    return Axios.get(`/articulos/${id}`)
  }

  searchRequest (nombre: string): AxiosPromise<{data: Articulo[]}> {
    return Axios.get(`/search?q=${nombre}`)
  }

  uploadImage (data: object) {
    return Axios.post('/articulos/image/upload', data)
  }

  toggleEstadoRequest (id: string, estado: number) {
    return Axios.put(`/articulos/estado/${id}`, { estado })
  }

  getEmpty () {
    return getEmptyArticulo()
  }
}
